import React from "react";
import _ from "lodash";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import GooglePlaceAutoComplete from "../../shared/GooglePlaceAutoComplete";
import { InputLabel } from "@material-ui/core";
import type { } from "@material-ui/lab/themeAugmentation";

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: "100%",
        marginBottom: "12px",
      },
    },
    MuiInput: {
      formControl: {
        marginTop: "0 !important",
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        borderRadius: "6px",
        backgroundColor: "rgba(2, 72, 157, 0.14) !important",
        color: "#fff",
        paddingTop: "4px !important",
        paddingBottom: "4px !important",
        fontSize: "16px",
        lineHeight: "19px",
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff",
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: "uppercase",
        fontFamily: "Lato",
        fontSize: "14px",
        lineHeight: "17px",
        padding: "0",
        color: "rgba(255, 255, 255, 0.5)",
        marginBottom: "10px",
      },
      formControl: {
        position: "inherit",
        transform: "none",
        marginBottom: "12px",
      },
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "&:hover $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
      },
    },    
  },
});

const AutoCompleteField = ({ placeholder, addressString, setAddressString, location, setLocation, label }: any) => {
  return (
    <ThemeProvider theme={theme}>
      {label && <InputLabel variant="standard">{label}</InputLabel>}
      <GooglePlaceAutoComplete
        onInputChange={(value: any) => {
          setAddressString(value);
          setLocation({})
        }}
        value={location?.eventLocationGooglePlaceId || ""}
        onChange={(r: any) => {
          setLocation({
            eventLocationGooglePlaceId: r?.place_id,
            eventLocationLatitude: r?.lat,
            eventLocationLongitude: r?.lng,
          });
        }}
        singleLine={true}
        hideNoOption={true}
        inputValue={addressString}
        placeholder={placeholder}
      />
    </ThemeProvider>
  );
};

export default AutoCompleteField;
